import React, { PureComponent } from "react";
import AbbreviatedMillionNumberFormat from "../../ui-building-blocks/numbers/AbbreviatedMillionNumberFormat";
import { detectMobile } from "../../../services/utils";

class ExpandWidget extends PureComponent {
  constructor(props) {
    super(props);

    this.isMobile = detectMobile();
  }

  getObject(year) {
    let projection = this.props.projections.find(
      i => i.target_round_number === year
    );

    if (!projection) {
      return {};
    }

    return projection;
  }

  getObjectValue(obj, key) {
    if (key in obj) {
      return obj[key];
    }

    return 0;
  }

  getYearNumber(offset) {
    const { currentRound, roundInUrl } = this.props;
    let current_round = currentRound;
    if (roundInUrl !== null && roundInUrl !== currentRound) {
      current_round = roundInUrl;
    }

    return current_round + offset;
  }

  get year1() {
    return this.getYearNumber(0);
  }

  /**
   * getUnits
   */
  getUnits = year => this.getObjectValue(this.getObject(year), "units_sold");

  get unitsYear1() {
    return this.getUnits(this.year1);
  }

  /**
   * getAvgSellingPrice
   */
  getAvgSellingPrice = year =>
    this.getObjectValue(this.getObject(year), "average_selling_price");

  get avgSellingPriceYear1() {
    return this.getAvgSellingPrice(this.year1);
  }

  /**
   * getTotalRevenues
   */
  getTotalRevenues = year =>
    this.getUnits(year) * this.getAvgSellingPrice(year);

  get totalRevenuesYear1() {
    return this.getTotalRevenues(this.year1);
  }

  /**
   * getAvgUnitCosts
   */
  getAvgUnitCosts = year =>
    this.getObjectValue(this.getObject(year), "average_unit_costs");

  get avgUnitCostsYear1() {
    return this.getAvgUnitCosts(this.year1);
  }

  /**
   * getCostOfSales
   */
  getCostOfSales = year => this.getUnits(year) * this.getAvgUnitCosts(year);

  get costOfSalesYear1() {
    return this.getCostOfSales(this.year1);
  }

  /**
   * getGrossProfits
   */
  getGrossProfits = year =>
    this.getTotalRevenues(year) - this.getCostOfSales(year);

  get grossProfitsYear1() {
    return this.getGrossProfits(this.year1);
  }

  /**
   * getTotalOperatingExpenses
   */
  getTotalOperatingExpenses = year =>
    this.getObjectValue(this.getObject(year), "other_operating_costs");

  get totalOperatingExpensesYear1() {
    return this.getTotalOperatingExpenses(this.year1);
  }

  /**
   * getOperatingProfits
   */
  getOperatingProfits = year =>
    this.getGrossProfits(year) - this.getTotalOperatingExpenses(year);

  get operatingProfitsYear1() {
    return this.getOperatingProfits(this.year1);
  }

  /**
   * getNonOperatingExpenses
   */
  getNonOperatingExpenses = year =>
    this.getObjectValue(this.getObject(year), "non_operating_expenses");

  get nonOperatingExpensesYear1() {
    return this.getNonOperatingExpenses(this.year1);
  }

  /**
   * getIncomeBeforeTaxes
   */
  getIncomeBeforeTaxes = year =>
    this.getOperatingProfits(year) - this.getNonOperatingExpenses(year);

  get incomeBeforeTaxesYear1() {
    return this.getIncomeBeforeTaxes(this.year1);
  }

  /**
   * getTaxes
   */
  getTaxes = year =>
    this.getIncomeBeforeTaxes(year) < 0
      ? 0
      : this.getIncomeBeforeTaxes(year) * 0.3 * -1;

  get taxesYear1() {
    return this.getTaxes(this.year1);
  }

  /**
   * getNetIncome
   */
  getNetIncome = year =>
    this.getIncomeBeforeTaxes(year) - Math.abs(this.getTaxes(year));

  get netIncomeYear1() {
    return this.getNetIncome(this.year1);
  }

  get currentYear() {
    const { currentRound, roundInUrl } = this.props;

    let current_round = currentRound;
    if (roundInUrl !== null && roundInUrl !== currentRound) {
      current_round = roundInUrl;
    }

    return current_round;
  }

  render() {
    const divStyle = this.isMobile
      ? {
          padding: 0,
          marginBottom: 0
        }
      : {};

    return (
      <div className="panel-dashboard-white-full" style={divStyle}>
        <h5>INCOME STATEMENT</h5>
        <div className="table-responsive">
          <table className="table">
            <thead>
              <tr>
                <th className="table-title text-center">
                  <span />
                </th>
                <th className="table-title text-center">
                  <span className="block">YEAR {this.year1}</span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr className="text-center">
                <th className="sub-title">Expected Revenues</th>
                <td />
              </tr>
              <tr className="text-center">
                <th className="description">
                  <hr />
                  Units
                </th>
                <td>
                  <hr />
                  <AbbreviatedMillionNumberFormat value={this.unitsYear1} />
                </td>
              </tr>
              <tr className="text-center">
                <th className="description">
                  <hr />
                  Average Selling Price
                </th>
                <td>
                  <hr />
                  <AbbreviatedMillionNumberFormat
                    value={this.avgSellingPriceYear1}
                    prefix="$"
                  />
                </td>
              </tr>
              <tr className="text-center">
                <th className="description">
                  <hr />
                  Total Revenues
                </th>
                <td>
                  <hr />
                  <AbbreviatedMillionNumberFormat
                    value={this.totalRevenuesYear1}
                    prefix="$"
                  />
                </td>
              </tr>
              <tr className="text-center">
                <th className="sub-title">Cost of Sales</th>
                <td />
              </tr>
              <tr className="text-center">
                <th className="description">
                  <hr />
                  Units
                </th>
                <td>
                  <hr />
                  <AbbreviatedMillionNumberFormat value={this.unitsYear1} />
                </td>
              </tr>
              <tr className="text-center">
                <th className="description">
                  <hr />
                  Average Unit Costs
                </th>
                <td>
                  <hr />
                  <AbbreviatedMillionNumberFormat
                    value={this.avgUnitCostsYear1}
                    prefix="$"
                  />
                </td>
              </tr>
              <tr className="text-center">
                <th className="description">
                  <hr />
                  Cost of Sales
                </th>
                <td>
                  <hr />
                  <AbbreviatedMillionNumberFormat
                    value={this.costOfSalesYear1}
                    prefix="$"
                  />
                </td>
              </tr>
              <tr className="text-center">
                <th className="description">
                  <hr />
                  Gross Profits
                </th>
                <td>
                  <hr />
                  <AbbreviatedMillionNumberFormat
                    value={this.grossProfitsYear1}
                    prefix="$"
                  />
                </td>
              </tr>
              <tr className="text-center">
                <th className="sub-title">Operating Expenses</th>
                <td />
              </tr>
              <tr className="text-center">
                <th className="description">
                  <hr />
                  Total Operating Expenses
                </th>
                <td>
                  <hr />
                  <AbbreviatedMillionNumberFormat
                    value={this.totalOperatingExpensesYear1}
                    prefix="$"
                  />
                </td>
              </tr>
              <tr className="text-center">
                <th className="description">
                  <hr />
                  Operating Profit
                </th>
                <td>
                  <hr />
                  <AbbreviatedMillionNumberFormat
                    value={this.operatingProfitsYear1}
                    prefix="$"
                  />
                </td>
              </tr>
              <tr className="text-center">
                <th className="sub-title">Non-Operating Costs</th>
                <td />
              </tr>
              <tr className="text-center">
                <th className="description">
                  <hr />
                  Total Non-Operating Costs
                </th>
                <td>
                  <hr />
                  <AbbreviatedMillionNumberFormat
                    value={this.nonOperatingExpensesYear1}
                    prefix="$"
                  />
                </td>
              </tr>
              <tr className="text-center">
                <th className="sub-title">Profits</th>
                <td />
              </tr>
              <tr className="text-center">
                <th className="description">
                  <hr />
                  Income Before Taxes
                </th>
                <td>
                  <hr />
                  <AbbreviatedMillionNumberFormat
                    value={this.incomeBeforeTaxesYear1}
                    prefix="$"
                  />
                </td>
              </tr>
              <tr className="text-center">
                <th className="description">
                  <hr />
                  Taxes (35%)
                </th>
                <td>
                  <hr />
                  <AbbreviatedMillionNumberFormat
                    value={this.taxesYear1}
                    prefix="$"
                  />
                </td>
              </tr>
              <tr className="text-center">
                <th className="description">
                  <hr />
                  Net Profits
                </th>
                <td>
                  <hr />
                  <AbbreviatedMillionNumberFormat
                    value={this.netIncomeYear1}
                    prefix="$"
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}

export default ExpandWidget;



// WEBPACK FOOTER //
// ./src/components/ceo/decisions/expand-widget.js